import type { NotificationEvent } from "./types";

// Module-level pub/sub so every screen can subscribe to the single WebSocket
// connection App.tsx owns, without prop-drilling or a context provider.
type Handler = (evt: NotificationEvent) => void;

const handlers = new Set<Handler>();

export const wsBus = {
  emit(evt: NotificationEvent): void {
    for (const h of handlers) {
      try {
        h(evt);
      } catch {
        // a misbehaving subscriber must not poison the others
      }
    }
  },
  subscribe(h: Handler): () => void {
    handlers.add(h);
    return () => handlers.delete(h);
  },
};
